/** @deprecated use the one in userSettingsUtils instead */
export const getSettingDisabledOpts = (
  canEditPreferenceType = true,
  canSelectPreferenceOption = true
): { disabled: boolean; tooltip?: string } => {
  if (!canEditPreferenceType) {
    return {
      disabled: true,
      tooltip: "Enforced by your Workspace",
    };
  }

  if (!canSelectPreferenceOption) {
    return {
      disabled: true,
      tooltip: "Not available for your Workspace",
    };
  }

  return { disabled: false };
};
